import gql from 'graphql-tag';

export default gql`
  mutation updateGroupRole($groupRole: GroupRoleInput!) {
    updateGroupRole(groupRole: $groupRole) {
      _id
    }
  }
`;
